import colorsOptions from '../../fundamentals/colors-styles/constants.js'
import {
  TrailingNeutral,
  TrailingInfo,
  TrailingWarning,
  TrailingError,
  TrailingSuccess
} from '../../atoms/icons/static-banner'

export const staticBannerVariantOptions = {
  NEUTRAL: 'neutral',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success'
}

export const staticBannerStyleOptions = {
  [staticBannerVariantOptions.NEUTRAL]: {
    backgroundColor: colorsOptions.greys['grey-20'],
    borderColor: colorsOptions.greys['grey-90'],
    color: colorsOptions.greys['grey-90'],
    icon: <TrailingNeutral />
  },
  [staticBannerVariantOptions.INFO]: {
    backgroundColor: colorsOptions.semantics.info.pale,
    borderColor: colorsOptions.semantics.info.strong,
    color: colorsOptions.semantics.info.strong,
    icon: <TrailingInfo />
  },
  [staticBannerVariantOptions.WARNING]: {
    backgroundColor: colorsOptions.semantics.warning.pale,
    borderColor: colorsOptions.semantics.warning.strong,
    color: colorsOptions.semantics.warning.strong,
    icon: <TrailingWarning />
  },
  [staticBannerVariantOptions.ERROR]: {
    backgroundColor: colorsOptions.secondaryColors.red.pale,
    borderColor: colorsOptions.semantics.danger['error-50'],
    color: colorsOptions.semantics.danger['error-50'],
    icon: <TrailingError />
  },
  [staticBannerVariantOptions.SUCCESS]: {
    backgroundColor: colorsOptions.semantics.success.pale,
    borderColor: colorsOptions.semantics.success.strong,
    color: colorsOptions.semantics.success.strong,
    icon: <TrailingSuccess />
  }
}
